import { render, staticRenderFns } from "./NotesForm.vue?vue&type=template&id=4365f16e&scoped=true"
import script from "./NotesForm.vue?vue&type=script&lang=js"
export * from "./NotesForm.vue?vue&type=script&lang=js"
import style0 from "./NotesForm.vue?vue&type=style&index=0&id=4365f16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4365f16e",
  null
  
)

export default component.exports